import React, { useEffect, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";

// Keeping only your active light logo asset as requested
import logoLight from "../assets/images/logo/logo-white.png";
import logoSm from "../assets/images/logo/logo-small.png";

// Import Components
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";
import TwoColumnLayout from "./TwoColumnLayout";
import VerticalLayout from "./VerticalLayouts";

const Sidebar = ({ layoutType }) => {
  // ✅ FIX: Proper event listener setup with cleanup
  useEffect(() => {
    const verticalOverlay = document.querySelector(".vertical-overlay");

    if (verticalOverlay) {
      const handleOverlayClick = () => {
        document.body.classList.remove("vertical-sidebar-enable");
      };

      verticalOverlay.addEventListener("click", handleOverlayClick);

      // ✅ CLEANUP: Remove listener on unmount
      return () => {
        verticalOverlay.removeEventListener("click", handleOverlayClick);
      };
    }
  }, []); // Empty dependency - runs once on mount

  // ✅ FIX: Memoize hover menu handler to prevent recreation on every render
  const addEventListenerOnSmHoverMenu = useCallback(() => {
    const rootElement = document.documentElement;
    const currentSize = rootElement.getAttribute("data-sidebar-size");

    if (currentSize === "sm-hover") {
      rootElement.setAttribute("data-sidebar-size", "sm-hover-active");
    } else if (currentSize === "sm-hover-active") {
      rootElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      rootElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  }, []);

  // ✅ FIX: Choose layout component based on layoutType
  const layoutComponent = useMemo(() => {
    if (layoutType === "horizontal") {
      return (
        <div id="scrollbar">
          <Container fluid>
            <div id="two-column-menu"></div>
            <ul className="navbar-nav" id="navbar-nav">
              <HorizontalLayout />
            </ul>
          </Container>
        </div>
      );
    } else if (layoutType === "twocolumn") {
      return (
        <React.Fragment>
          <TwoColumnLayout layoutType={layoutType} />
          <div className="sidebar-background"></div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <SimpleBar id="scrollbar" className="h-100">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <VerticalLayout layoutType={layoutType} />
              </ul>
            </Container>
          </SimpleBar>
          <div className="sidebar-background"></div>
        </React.Fragment>
      );
    }
  }, [layoutType]); // Only recalculate when layoutType changes

  return (
    <React.Fragment>
      {/* Target custom-structured premium layout utility wrapper */}
      <div className="app-menu navbar-menu shelter-premium-native-sidebar">
        {/* Main Brand Box matching your exact native height and structure */}
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoLight} alt="Shelter U" height="60" />
            </span>
          </Link>

          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover d-none"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>

        {layoutComponent}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

// ✅ MEMOIZE: Only rerender when layoutType prop changes
export default React.memo(Sidebar, (prevProps, nextProps) => {
  return prevProps.layoutType === nextProps.layoutType;
});
